import React, { useEffect, useState, useRef, useCallback } from "react";
import "./Feeds.css";
import { getAllVotesWithFilters, getSubVoteByOption } from "../../api/Vote";
import { submitVote, likeDislike, addComment, getAllComments, addBookmark, deleteComment, getAllBookmark, deleteBookmark, viewBallot } from "../../api/Vote";
import SubBallotModal from "../SubBallotModal/SubBallotModal";
import VoteFilters from "../VoteFilters/VoteFilters";
import { getUser } from "../../api/auth";
import { getUserId, getToken } from "../../api/index";
import SendRoundedIcon from '@mui/icons-material/SendRounded';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ShareIcon from '@mui/icons-material/Share';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import CircularProgress from '@mui/material/CircularProgress';
import FaceRecognition from '../FaceRecognition/FaceRecognition';
import CloseIcon from '@mui/icons-material/Close';
import Loader from '../Loader';
import SubscriptionPrompt from '../Shared/SubscriptionPrompt';
import { useSelector, useDispatch } from 'react-redux';
import { setUserDetails } from '../../Redux/Slices/userDetailsSlice';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';
import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded';
import FavoriteBorderRoundedIcon from '@mui/icons-material/FavoriteBorderRounded';
import KeyboardArrowUpRoundedIcon from '@mui/icons-material/KeyboardArrowUpRounded';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import PictureAsPdfRoundedIcon from '@mui/icons-material/PictureAsPdfRounded';
import ChatBubbleOutlineRoundedIcon from '@mui/icons-material/ChatBubbleOutlineRounded';
import NearMeOutlinedIcon from '@mui/icons-material/NearMeOutlined';
import { getHumanizedTime } from '../getHumanizedTime';
import ProfileCompletionPrompt from "../Shared/ProfileCompletionPrompt";
import useGovtIdVerification from '../../hooks/useGovtIdVerification';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import ShareModal from '../Shared/ShareModal';

function Feeds({ initialVotes, isInitialLoading, refreshTrigger, onRefresh }) {
  const [allVotes, setAllVotes] = useState(initialVotes || []);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(isInitialLoading);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [hasMoreVotes, setHasMoreVotes] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize] = useState(5);
  const userId = localStorage.getItem("userId");
  const [openComments, setOpenComments] = useState({});
  const [commentText, setCommentText] = useState("");
  const [allComments, setAllComments] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });
  const [selectedCardId, setSelectedCardId] = useState(null);
  const [selectedFiles, setSelectedFiles] = useState({});
  const [filePreviews, setFilePreviews] = useState({});
  const fileInputRef = useRef(null);
  const [shareDialogOpen, setShareDialogOpen] = useState(false);
  const [selectedVoteForShare, setSelectedVoteForShare] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [isSignIn, setIsSignIn] = useState(false);
  const [faceRecognitionDialogOpen, setFaceRecognitionDialogOpen] = useState(false);
  const [pendingVote, setPendingVote] = useState(null);
  const [isUserVerified, setIsUserVerified] = useState('');
  const [isSubscribed, setIsSubscribed] = useState(true); // assume subscribed until checked
  const [isSubscriptionEnable, setIsSubscriptionEnable] = useState(false);
  const [subscriptionDialogOpen, setSubscriptionDialogOpen] = useState(false);
  const [profilePromptOpen, setProfilePromptOpen] = useState(false);
  const [profilePromptMessage, setProfilePromptMessage] = useState('');
  const [unmutedVideoId, setUnmutedVideoId] = useState(null);
  const dispatch = useDispatch();

  const [isReportClicked, setIsReportClicked] = useState(false);
  const [playingVideos, setPlayingVideos] = useState({});
  const [imageLoading, setImageLoading] = useState({});
  const [videoLoading, setVideoLoading] = useState({});
  const [commentMediaLoading, setCommentMediaLoading] = useState({});
  const [previewLoading, setPreviewLoading] = useState({});
  const [profileImageLoading, setProfileImageLoading] = useState({});
  const [commentProfileLoading, setCommentProfileLoading] = useState({});
  const [bookmarkedVotes, setBookmarkedVotes] = useState([]);

  const [commentLoader, setCommentLoader] = useState(false);
  const [votingLoader, setVotingLoader] = useState({}); // Track loading state for each vote option: { "voteId-optionId": true }

  const voteRefs = useRef({});
  const viewStartTimes = useRef({});
  const viewTimeouts = useRef({});

  // Sub-ballot state
  const [subBallot, setSubBallot] = useState(null);
  const [isSubBallotOpen, setIsSubBallotOpen] = useState(false);
  const [parentOptionText, setParentOptionText] = useState("");
  const [isSubBallotVoting, setIsSubBallotVoting] = useState(false);
  const [activeFilters, setActiveFilters] = useState({
    all: true,
    recentlyAdded: false,
    expiringSoon: false,
    isFaceRequired: false,
    isLocation: false,
    isNotVoted: false,
    mostPopular: false,
    mostUnanimous: false,
    mostDivided: false,
    mostLiked: false,
    mostCommented: false
  });
  const storedUserDetails = useSelector((state) => state.userDetails?.userDetails);
  const govtHook = useGovtIdVerification();
  // Helper function to get user initials
  const getUserInitials = (userName) => {
    if (!userName) return '';
    const words = userName.trim().split(' ');
    if (words.length === 1) {
      return words[0].charAt(0).toUpperCase();
    }
    const firstInitial = words[0] ? words[0].charAt(0).toUpperCase() : '';
    const lastInitial = words[words.length - 1] ? words[words.length - 1].charAt(0).toUpperCase() : '';
    return firstInitial + lastInitial;
  };

  // Helper function to generate background color based on initials
  const getBackgroundColor = (initials) => {
    const colors = [
      '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4',
      '#FFEAA7', '#DDA0DD', '#98D8C8', '#F7DC6F',
      '#BB8FCE', '#85C1E9', '#F8C471', '#82E0AA'
    ];

    let hash = 0;
    for (let i = 0; i < initials.length; i++) {
      hash = initials.charCodeAt(i) + ((hash << 5) - hash);
    }
    hash = Math.abs(hash);
    return colors[hash % colors.length];
  };

  // Helper functions for loading states
  const handleImageLoad = (id, type) => {
    if (type === 'main') {
      setImageLoading(prev => ({ ...prev, [id]: false }));
    } else if (type === 'profile') {
      setProfileImageLoading(prev => ({ ...prev, [id]: false }));
    } else if (type === 'comment') {
      setCommentMediaLoading(prev => ({ ...prev, [id]: false }));
    } else if (type === 'preview') {
      setPreviewLoading(prev => ({ ...prev, [id]: false }));
    } else if (type === 'commentProfile') {
      setCommentProfileLoading(prev => ({ ...prev, [id]: false }));
    }
  };

  const handleImageError = (id, type) => {
    if (type === 'main') {
      setImageLoading(prev => ({ ...prev, [id]: false }));
    } else if (type === 'profile') {
      setProfileImageLoading(prev => ({ ...prev, [id]: false }));
    } else if (type === 'comment') {
      setCommentMediaLoading(prev => ({ ...prev, [id]: false }));
    } else if (type === 'preview') {
      setPreviewLoading(prev => ({ ...prev, [id]: false }));
    } else if (type === 'commentProfile') {
      setCommentProfileLoading(prev => ({ ...prev, [id]: false }));
    }
  };

  const handleVideoLoad = (id, type) => {
    if (type === 'main') {
      setVideoLoading(prev => ({ ...prev, [id]: false }));
    } else if (type === 'comment') {
      setCommentMediaLoading(prev => ({ ...prev, [id]: false }));
    } else if (type === 'preview') {
      setPreviewLoading(prev => ({ ...prev, [id]: false }));
    }
  };

  const setMediaLoading = (id, type, isLoading) => {
    if (type === 'main-image') {
      setImageLoading(prev => ({ ...prev, [id]: isLoading }));
    } else if (type === 'main-video') {
      setVideoLoading(prev => ({ ...prev, [id]: isLoading }));
    } else if (type === 'profile') {
      setProfileImageLoading(prev => ({ ...prev, [id]: isLoading }));
    } else if (type === 'comment') {
      setCommentMediaLoading(prev => ({ ...prev, [id]: isLoading }));
    } else if (type === 'preview') {
      setPreviewLoading(prev => ({ ...prev, [id]: isLoading }));
    } else if (type === 'commentProfile') {
      setCommentProfileLoading(prev => ({ ...prev, [id]: isLoading }));
    }
  };

  // const formatRelativeTime = (dateString) => {
  //   // Convert UTC to IST by adding 5 hours and 30 minutes
  //   const date = new Date(dateString);
  //   date.setHours(date.getHours() + 5);
  //   date.setMinutes(date.getMinutes() + 30);

  //   const now = new Date();
  //   const diffMs = now - date;

  //   // Configure humanize duration
  //   const shortHumanizer = humanizeDuration.humanizer({
  //     language: 'shortEn',
  //     languages: {
  //       shortEn: {
  //         y: () => 'y',
  //         mo: () => 'mo',
  //         w: () => 'w',
  //         d: () => 'd',
  //         h: () => 'h',
  //         m: () => 'm',
  //         s: () => 's',
  //         ms: () => 'ms',
  //       }
  //     },
  //     largest: 1,
  //     round: true,
  //     spacer: '',
  //     units: ['y', 'mo', 'd', 'h', 'm'],
  //   });

  //   if (diffMs < 60000) { // less than 1 minute
  //     return 'just now';
  //   }

  //   return shortHumanizer(diffMs) + ' ago';
  // };

  const handleAllVotes = useCallback(async (isInitialLoad = true, filters = activeFilters) => {
    if (isInitialLoad) {
      setIsLoading(true);
      setCurrentPage(0);
      setAllVotes([]);
    } else {
      setIsLoadingMore(true);
    }

    const token = getToken();
    try {
      const skip = isInitialLoad ? 0 : currentPage * pageSize;

      // Prepare filter parameters based on active filters
      const filterParams = {
        userId: userId,
        skip: skip,
        take: pageSize,
        recentlyAdded: filters.recentlyAdded,
        expiringSoon: filters.expiringSoon,
        isFaceRequired: filters.isFaceRequired,
        isLocation: filters.isLocation,
        isNotVoted: filters.isNotVoted,
        mostPopular: filters.mostPopular,
        mostUnanimous: filters.mostUnanimous,
        mostDivided: filters.mostDivided,
        mostLiked: filters.mostLiked,
        mostCommented: filters.mostCommented
      };

      const response = await getAllVotesWithFilters(filterParams, token);
      console.log(" response from getAllVotesWithFilters api:", response);

      // Ensure response is an array
      const votesArray = Array.isArray(response) ? response : (response?.data ? response.data : []);

      if (isInitialLoad) {
        setAllVotes(votesArray);
      } else {
        setAllVotes(prevVotes => [...prevVotes, ...votesArray]);
      }

      // Check if we have more votes to load
      if (votesArray.length < pageSize) {
        setHasMoreVotes(false);
      } else {
        setCurrentPage(prev => prev + 1);
      }
    } catch (error) {
      console.log("error", error);
      // Set empty array on error to prevent map errors
      if (isInitialLoad) {
        setAllVotes([]);
      }
    } finally {
      setIsLoading(false);
      setIsLoadingMore(false);
    }
  }, [activeFilters, currentPage, pageSize, userId]);

  const loadMoreVotes = useCallback(async () => {
    if (!isLoadingMore && hasMoreVotes) {
      await handleAllVotes(false);
    }
  }, [isLoadingMore, hasMoreVotes, handleAllVotes]);

  useEffect(() => {
    if (initialVotes) {
      console.log("Using shared initial votes in Feeds");
      setAllVotes(initialVotes);
      // Adjust currentPage based on the amount of initial data
      if (initialVotes.length > 0) {
        setCurrentPage(Math.ceil(initialVotes.length / pageSize));
      } else {
        setCurrentPage(0);
      }
    }
  }, [initialVotes]);

  useEffect(() => {
    setIsLoading(isInitialLoading);
  }, [isInitialLoading]);

  useEffect(() => {
    if (refreshTrigger > 0) {
      console.log("Triggering re-fetch in Feeds due to refreshTrigger");
      handleAllVotes(true);
    }
  }, [refreshTrigger, handleAllVotes]);

  useEffect(() => {
    if (!initialVotes || initialVotes.length === 0) {
      handleAllVotes();
    }
  }, [handleAllVotes, initialVotes]);

  // Scroll detection for lazy loading
  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + document.documentElement.scrollTop >=
        document.documentElement.offsetHeight - 1000 // Load more when 1000px from bottom
      ) {
        loadMoreVotes();
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isLoadingMore, hasMoreVotes, currentPage, loadMoreVotes]);

  const handleBookmarkedVotes = async () => {
    try {
      const token = getToken();
      const response = await getAllBookmark(token);
      console.log(" response from getAllBookmark api:", response);
      setBookmarkedVotes(response);
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    const token = getToken();
    const userId = getUserId(); // Updated to use localStorage
    const getUserDetails = async () => {
      const response = await getUser(userId, token);
      console.log(" response from getUser api:", response.data);
      dispatch(setUserDetails(response.data));

      // store user details in redux for other components
      if (response?.data) {
        dispatch(setUserDetails(response.data));
      }
      if (response?.data?.governmentId?.isVerified) {
        setIsUserVerified('approved');
      } else {
        setIsUserVerified('notUploaded');
      }
    }
    getUserDetails();
    handleBookmarkedVotes();
  }, [dispatch]);

  // Keep local subscription state in sync with redux-stored user details
  useEffect(() => {
    if (storedUserDetails && typeof storedUserDetails.isSubscribed !== 'undefined') {
      setIsSubscribed(!!storedUserDetails.isSubscribed);
      setIsSubscriptionEnable(!!storedUserDetails.isSubscriptionEnable);
    }
  }, [storedUserDetails]);

  useEffect(() => {
    console.log("isUserVerified", isUserVerified);
  }, [isUserVerified]);

  // Effect to handle body scrolling when popup is open
  useEffect(() => {
    if (showPopup) {
      // Disable scrolling
      document.body.style.overflow = 'hidden';
    } else {
      // Re-enable scrolling
      document.body.style.overflow = 'unset';
    }

    // Cleanup function to ensure scrolling is re-enabled when component unmounts
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [showPopup]);

  // View tracking observer
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const voteId = entry.target.dataset.voteId;
          const currentUserId = getUserId();

          if (!voteId) return;

          if (entry.isIntersecting) {
            // Start timing response time
            if (!viewStartTimes.current[voteId]) {
              viewStartTimes.current[voteId] = Date.now();
            }

            // Set timeout for 1 second view recording
            if (!viewTimeouts.current[voteId]) {
              viewTimeouts.current[voteId] = setTimeout(async () => {
                if (currentUserId) {
                  try {
                    await viewBallot({ voteId: voteId, userId: currentUserId });
                    console.log("View recorded for", voteId);
                  } catch (error) {
                    console.error("Error recording view:", error);
                  }
                }
              }, 1000);
            }
          } else {
            // Cleared from view
            if (viewTimeouts.current[voteId]) {
              clearTimeout(viewTimeouts.current[voteId]);
              delete viewTimeouts.current[voteId];
            }
            // Reset start time when out of view
            delete viewStartTimes.current[voteId];
          }
        });
      },
      { threshold: 0.6 } // 60% visibility required
    );

    // Observe all current vote refs
    Object.values(voteRefs.current).forEach((el) => {
      if (el) observer.observe(el);
    });

      return () => observer.disconnect();
  }, [allVotes]);

  const isProfileComplete = () => {
    const u = storedUserDetails;
    console.log("u", u);
    if (!u) return false;
    const hasName = !!((u.firstName && u.firstName.trim()) || (u.lastName && u.lastName.trim()));
    console.log("hasName", hasName);
    const hasDob = !!u.dateOfBirth;
    console.log("hasDob", hasDob);
    const hasAddress = Array.isArray(u.addresses) ? u.addresses.length > 0 : !!u.address;
    return hasName && hasDob && hasAddress;
  };

  const guardAnd = (action) => {
    // Profile first
    if (!isProfileComplete()) {
      setProfilePromptOpen(true);
      setSubscriptionDialogOpen(false);
      return false;
    }
    // Government ID presence
    const govCheck = govtHook.check();
    if (!govCheck.allowed) {
      setProfilePromptMessage(govCheck.reason);
      setProfilePromptOpen(true);
      setSubscriptionDialogOpen(false);
      return false;
    }
    // Subscription next
    if (isSubscriptionEnable && !isSubscribed) {
      setSubscriptionDialogOpen(true);
      setProfilePromptOpen(false);
      return false;
    }
    setProfilePromptOpen(false);
    setSubscriptionDialogOpen(false);
    return true;
  };

  const handleSubmitVote = async (voteId, optionId) => {
    if (!guardAnd('vote')) return;

    // Calculate response time
    const startTime = viewStartTimes.current[voteId];
    let responseTime = null;
    if (startTime) {
      responseTime = Date.now() - startTime;
    }

    // Check if this vote requires face verification
    const vote = allVotes.find(v => v.voteId === voteId);
    if (vote && vote.isFaceRequired) {
      setPendingVote({ voteId, optionId, responseTime });
      setFaceRecognitionDialogOpen(true);
    } else {
      // Submit vote directly without face verification
      const token = getToken();
      const userId = getUserId();
      const loadingKey = `${voteId}-${optionId}`;

      // Set loading state for this specific button
      setVotingLoader(prev => ({ ...prev, [loadingKey]: true }));

      try {
        const response = await submitVote({ voteId, userId, optionId, responseTime }, token);
        console.log("Vote response:", response);

        setAllVotes(prevVotes =>
          prevVotes.map(v => {
            if (v.voteId === voteId) {
              // Use the response data if available, otherwise fallback to manual update
              if (response?.data?.options) {
                return {
                  ...v,
                  isVoted: true,
                  selectedOptionId: optionId,
                  options: response.data.options.map(option => ({
                    ...option,
                    isSelected: option.id.toLowerCase() === optionId.toLowerCase()
                  }))
                };
              } else {
                return {
                  ...v,
                  isVoted: true,
                  selectedOptionId: optionId,
                  options: v.options.map(option => ({
                    ...option,
                    isSelected: option.id === optionId
                  }))
                };
              }
            }
            return v;
          })
        );
        // Dispatch event to update progress bar
        window.dispatchEvent(new Event('voteSubmitted'));
        // Don't call handleAllVotes(true) - it causes full-screen loader
        // The state update above is sufficient
      } catch (error) {
        console.log("error", error);
      } finally {
        // Remove loading state for this button
        setVotingLoader(prev => {
          const newState = { ...prev };
          delete newState[loadingKey];
          return newState;
        });
      }

      // Try to fetch sub-ballot (after voting)
      try {
        console.log("🔍 Checking for sub-ballot for option:", optionId);
        const subVoteResponse = await getSubVoteByOption(optionId, userId);
        console.log("Sub-ballot response:", subVoteResponse);

        if (subVoteResponse && subVoteResponse.success && subVoteResponse.data) {
          console.log("✅ Sub-ballot found:", subVoteResponse.data);

          // Find the option text from the parent vote
          const parentVote = allVotes.find(v => v.voteId === voteId);
          const selectedOption = parentVote?.options.find(opt => opt.id === optionId);

          setSubBallot(subVoteResponse.data);
          setParentOptionText(selectedOption?.value || "your selection");
          setIsSubBallotOpen(true);
        } else {
          console.log("✓ No sub-ballot for this option");
        }
      } catch (err) {
        console.log("No sub-ballot found or error fetching:", err);
      }
    }
  };

  const handleSubBallotVote = async (optionId) => {
    if (!subBallot) return;

    const voteId = subBallot.voteId;
    const token = getToken();
    const userId = getUserId();

    setIsSubBallotVoting(true);

    try {
      console.log("📤 Submitting sub-ballot vote:", { voteId, optionId });
      const response = await submitVote({ voteId, userId, optionId }, token);
      console.log("✅ Sub-ballot vote response:", response);

      if (response?.data?.options) {
        setSubBallot(prev => ({
          ...prev,
          isVoted: true,
          selectedOptionId: optionId,
          options: response.data.options.map(option => ({
            ...option,
            isSelected: option.id.toLowerCase() === optionId.toLowerCase()
          }))
        }));
      } else {
        // Fallback manual update
        setSubBallot(prev => ({
          ...prev,
          isVoted: true,
          selectedOptionId: optionId,
          options: prev.options.map(option => ({
            ...option,
            isSelected: option.id === optionId
          }))
        }));
      }

      // Dispatch event to update progress bar (global listener)
      window.dispatchEvent(new Event('voteSubmitted'));

      // Auto-close modal after 2 seconds
      setTimeout(() => {
        handleCloseSubBallot();
      }, 2000);

    } catch (error) {
      console.error("❌ Error voting on sub-ballot:", error);
      setSnackbarMessage("Failed to submit vote. Please try again.");
      setSnackbarOpen(true);
    } finally {
      setIsSubBallotVoting(false);
    }
  };

  const handleCloseSubBallot = () => {
    setIsSubBallotOpen(false);
    setSubBallot(null);
    setParentOptionText("");
    setIsSubBallotVoting(false);
  };

  // Function to view sub-ballot (for button click)
  const handleViewSubBallot = async (voteId, optionId, optionText) => {
    const userId = getUserId();

    try {
      console.log("👀 Viewing sub-ballot for option:", optionId);
      const subVoteResponse = await getSubVoteByOption(optionId, userId);
      console.log("Sub-ballot response:", subVoteResponse);

      if (subVoteResponse && subVoteResponse.success && subVoteResponse.data) {
        console.log("✅ Sub-ballot found:", subVoteResponse.data);
        setSubBallot(subVoteResponse.data);
        setParentOptionText(optionText || "your selection");
        setIsSubBallotOpen(true);
      } else {
        setSnackbarMessage("No sub-ballot available for this option.");
        setSnackbarOpen(true);
      }
    } catch (err) {
      console.error("Error fetching sub-ballot:", err);
      setSnackbarMessage("Failed to load sub-ballot. Please try again.");
      setSnackbarOpen(true);
    }
  };

  useEffect(() => {
    if (isSignIn && pendingVote) {
      const submit = async () => {
        const token = getToken();
        const userId = getUserId();
        const loadingKey = `${pendingVote.voteId}-${pendingVote.optionId}`;

        // Set loading state for this specific button
        setVotingLoader(prev => ({ ...prev, [loadingKey]: true }));

        try {
          const response = await submitVote({ voteId: pendingVote.voteId, userId, optionId: pendingVote.optionId, responseTime: pendingVote.responseTime }, token);
          console.log("Vote response (face required):", response);

          setAllVotes(prevVotes =>
            prevVotes.map(vote => {
              if (vote.voteId === pendingVote.voteId) {
                // Use the response data if available, otherwise fallback to manual update
                if (response?.data?.options) {
                  return {
                    ...vote,
                    isVoted: true,
                    selectedOptionId: pendingVote.optionId,
                    options: response.data.options.map(option => ({
                      ...option,
                      isSelected: option.id.toLowerCase() === pendingVote.optionId.toLowerCase()
                    }))
                  };
                } else {
                  return {
                    ...vote,
                    isVoted: true,
                    selectedOptionId: pendingVote.optionId,
                    options: vote.options.map(option => ({
                      ...option,
                      isSelected: option.id === pendingVote.optionId
                    }))
                  };
                }
              }
              return vote;
            })
          );
          // Dispatch event to update progress bar
          window.dispatchEvent(new Event('voteSubmitted'));
          // Don't call handleAllVotes(true) - it causes full-screen loader
        } catch (error) {
          console.log("error", error);
        } finally {
          // Remove loading state for this button
          setVotingLoader(prev => {
            const newState = { ...prev };
            delete newState[loadingKey];
            return newState;
          });
        }
        setIsSignIn(false);
        setFaceRecognitionDialogOpen(false);
        setPendingVote(null);
      };
      submit();
    }
  }, [isSignIn, pendingVote]);

  const handleLikeDislike = async (voteId) => {
    console.log("voteId", voteId);
    const token = getToken();
    const userId = getUserId(); // Updated to use localStorage
    if (!guardAnd('like')) return;
    try {
      const response = await likeDislike({ voteId, userId }, token);
      console.log(" response from likeDislike api:", response);
      setAllVotes(prevVotes =>
        prevVotes.map(vote => {
          if (vote.voteId === voteId) {
            return {
              ...vote,
              isLiked: !vote.isLiked,
              likeCount: vote.isLiked ? vote.likeCount - 1 : vote.likeCount + 1
            };
          }
          return vote;
        })
      );
    } catch (error) {
      console.log("error", error);
    }
  }

  const handleCommentLikeDislike = async (voteId, commentId, action) => {
    const comment = allComments.find(c => c.commentId === commentId);
    if (!comment) return;

    if (action === 'up' && comment.isLiked) return;
    if (action === 'down' && !comment.isLiked) return;

    const token = getToken();
    const userId = getUserId();
    if (!guardAnd('like')) return;

    try {
      const response = await likeDislike({ voteId, userId, targetId: commentId, targetType: 1 }, token);
      console.log(" response from comment likeDislike api:", response);
      setAllComments(prevComments => {
        let updated = prevComments.map(c => {
          if (c.commentId === commentId) {
            return {
              ...c,
              isLiked: !c.isLiked,
              likeCount: c.isLiked ? Math.max(0, c.likeCount - 1) : c.likeCount + 1
            };
          }
          return c;
        });
        return updated.sort((a, b) => b.likeCount - a.likeCount);
      });
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleCommentIconClick = async (voteId, commentCount) => {
    // Close all other open comments except the one being toggled
    setOpenComments(prev => {
      const newState = {};
      // If we're opening this comment section, close all others and open this one
      if (!prev[voteId]) {
        newState[voteId] = true;
      }
      // If we're closing this comment section, just close it
      return newState;
    });

    // Clear any existing file previews and selections
    setSelectedFiles({});
    setFilePreviews(prev => {
      // Cleanup existing preview URLs
      Object.values(prev).forEach(url => {
        URL.revokeObjectURL(url);
      });
      return {};
    });
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }

    // Clear comments when closing
    if (openComments[voteId]) {
      setAllComments([]);
      return;
    }
    setAllComments([]);
    const token = getToken();
    if (commentCount > 0) {
      try {
        const response = await getAllComments(voteId, token);
        console.log(" response from getAllComments api:", response);
        const sortedComments = [...(response.comments || [])].sort((a, b) => b.likeCount - a.likeCount);
        setAllComments(sortedComments);
      } catch (error) {
        console.log("error", error);
      }
    }
  };

  const handleCommentSubmit = async (voteId) => {
    if (commentLoader) return;
    if (!guardAnd('comment')) return;
    setCommentLoader(true);
    console.log("commentText", commentText);
    console.log("voteId", voteId);
    const token = getToken();
    const userId = getUserId(); // Updated to use localStorage
    try {
      const formData = new FormData();
      formData.append("voteId", voteId);
      formData.append("userId", userId);

      if (commentText.length > 0) {
        formData.append("commentText", commentText);
      } else if (selectedFiles[voteId]) {
        const file = selectedFiles[voteId];
        console.log("File being sent:", file);

        // Append the file with its original name
        formData.append("Video", file);
      }
      const response = await addComment(formData, token);
      console.log(" response from addComment api:", response);

      // Clear the input after successful submission
      setCommentText("");
      if (selectedFiles[voteId]) {
        clearFileSelection(voteId);
      }

      // Update UI
      setAllVotes(prevVotes =>
        prevVotes.map(vote => {
          if (vote.voteId === voteId) {
            return {
              ...vote,
              commentCount: vote.commentCount + 1
            };
          }
          return vote;
        })
      );

      // Refresh comments
      const commentsResponse = await getAllComments(voteId, token);
      const sortedComments = [...(commentsResponse.comments || [])].sort((a, b) => b.likeCount - a.likeCount);
      setAllComments(sortedComments);
    } catch (error) {
      console.log("error", error);
    } finally {
      setCommentLoader(false);
    }
  };

  const handleHelpClick = (e, cardId, bookmarkId) => {
    e.preventDefault();
    e.stopPropagation();
    const rect = e.currentTarget.getBoundingClientRect();

    // Get viewport dimensions
    const viewportHeight = window.innerHeight;
    const viewportWidth = window.innerWidth;

    // Estimate popup dimensions (you can adjust these based on your CSS)
    const popupHeight = 200; // Adjust based on your popup height
    const popupWidth = 250; // Adjust based on your popup width

    // Calculate available space
    const spaceBelow = viewportHeight - rect.bottom;
    const spaceAbove = rect.top;
    const spaceRight = viewportWidth - rect.right;
    const spaceLeft = rect.left;

    // Determine vertical position
    let top;
    if (spaceBelow >= popupHeight) {
      // Position below the button
      top = rect.bottom;
    } else if (spaceAbove >= popupHeight) {
      // Position above the button
      top = rect.top - popupHeight;
    } else {
      // Center vertically if neither space is sufficient
      top = Math.max(0, (viewportHeight - popupHeight) / 2);
    }

    // Determine horizontal position
    let left;
    if (spaceLeft >= popupWidth) {
      // Position to the left of the button (current behavior)
      left = rect.left - popupWidth;
    } else if (spaceRight >= popupWidth) {
      // Position to the right of the button
      left = rect.right;
    } else {
      // Center horizontally if neither space is sufficient
      left = Math.max(0, (viewportWidth - popupWidth) / 2);
    }

    setPopupPosition({
      top: top,
      left: left
    });
    setSelectedCardId(cardId);
    setShowPopup(true);
    setIsReportClicked(false);
  };

  const handleClickOutside = (e) => {
    if (e.target.className === 'popupOverlay') {
      setShowPopup(false);
    }
  };

  const handleSave = async (voteId) => {
    console.log('Saving card:', voteId);
    setShowPopup(false);
    const token = getToken();
    const userId = getUserId(); // Updated to use localStorage
    try {
      const response = await addBookmark({ voteId, userId }, token);
      handleBookmarkedVotes();
      console.log(" response from addBookmark api:", response);
      setSnackbarMessage("Saved successfully");
      setSnackbarOpen(true);
    } catch (error) {
      console.log("error", error);
      setSnackbarMessage("Failed to save. Please try again.");
      setSnackbarOpen(true);
    }
  };
  const handleUnSave = async (voteId) => {
    setShowPopup(false);
    const token = getToken();
    const userId = getUserId(); // Updated to use localStorage
    const bookmark = bookmarkedVotes.find(item => item.voteId === voteId);
    const bookmarkId = bookmark?.bookmarkId;
    try {
      const response = await deleteBookmark({ voteId, userId, bookmarkId }, token);
      console.log(" response from deleteBookmark api:", response);
      setSnackbarMessage('Unsaved successfully');
      setSnackbarOpen(true);
    } catch (error) {
      console.log("error", error);
      setSnackbarMessage('Failed to unsave. Please try again.');
      setSnackbarOpen(true);
    }
    handleBookmarkedVotes();
  };

  const handleReport = () => {
    // console.log('Reporting card:', selectedCardId);
    setIsReportClicked(!isReportClicked);
    // setShowPopup(false);
  };
  const handleReportOption = (option) => {
    // setIsReportClicked(!isReportClicked);
    setShowPopup(false);
  }

  const handleFileSelect = (e, voteId) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFiles(prev => ({
        ...prev,
        [voteId]: file
      }));

      // Create preview URL
      const previewUrl = URL.createObjectURL(file);
      setFilePreviews(prev => ({
        ...prev,
        [voteId]: previewUrl
      }));

      // Clear text if there was any
      setCommentText("");
    }
  };

  const handlePlusClick = () => {
    fileInputRef.current?.click();
  };

  const clearFileSelection = (voteId) => {
    // Clear the specific file and preview
    setSelectedFiles(prev => {
      const newFiles = { ...prev };
      delete newFiles[voteId];
      return newFiles;
    });

    setFilePreviews(prev => {
      const newPreviews = { ...prev };
      if (newPreviews[voteId]) {
        URL.revokeObjectURL(newPreviews[voteId]);
        delete newPreviews[voteId];
      }
      return newPreviews;
    });

    // Reset the file input value
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  // Clean up preview URLs when component unmounts
  useEffect(() => {
    return () => {
      // Cleanup all previews
      Object.values(filePreviews).forEach(url => {
        URL.revokeObjectURL(url);
      });
    };
  }, [filePreviews]);

  const handleDeleteComment = async (commentId, voteId) => {
    const token = getToken();
    const userId = getUserId(); // Updated to use localStorage
    try {
      const response = await deleteComment({ commentId, userId }, token);
      console.log(" response from deleteComment api:", response);

      if (response) {
        // Update UI by removing the deleted comment
        setAllComments(prevComments =>
          prevComments.filter(comment => comment.commentId !== commentId)
        );

        // Update the comment count in the vote
        setAllVotes(prevVotes =>
          prevVotes.map(vote => {
            if (vote.voteId === voteId) {
              return {
                ...vote,
                commentCount: vote.commentCount - 1
              };
            }
            return vote;
          })
        );
      } else {
        throw new Error('Failed to delete comment');
      }

    } catch (error) {
      console.error("Error deleting comment:", error);
    }
  };

  const handleShare = async (vote) => {
    setSelectedVoteForShare(vote);
    setShareDialogOpen(true);
  };

  const handleSystemShare = async () => {
    const shareUrl = `${window.location.origin}/vote?voteId=${selectedVoteForShare.voteId}`;
    const shareData = {
      title: 'Share Vote',
      text: selectedVoteForShare.title,
      url: shareUrl,
    };

    try {
      if (navigator.share) {
        await navigator.share(shareData);
      }
    } catch (error) {
      console.error('Error sharing:', error);
    }
    setShareDialogOpen(false);
  };

  const handleCopyLink = () => {
    const shareUrl = `${window.location.origin}/vote?voteId=${selectedVoteForShare.voteId}`;
    navigator.clipboard.writeText(shareUrl).then(() => {
      setSnackbarMessage('Link copied to clipboard!');
      setSnackbarOpen(true);
      setShareDialogOpen(false);
    });
  };

  useEffect(() => {
    if (isSignIn) {
      setFaceRecognitionDialogOpen(false);
      setSnackbarOpen(true);
      setSnackbarMessage('Vote submitted successfully');
    }
  }, [isSignIn]);

  const handleVolumeToggle = (voteId, event) => {
    event.stopPropagation();
    setUnmutedVideoId(unmutedVideoId === voteId ? null : voteId);
  };

  const handleVideoPlayPause = (voteId, event) => {
    event.stopPropagation();
    const videoElement = event.target.closest('.voteMediaContainer').querySelector('video');

    if (videoElement) {
      if (playingVideos[voteId]) {
        videoElement.pause();
        setPlayingVideos(prev => ({ ...prev, [voteId]: false }));
      } else {
        videoElement.play();
        setPlayingVideos(prev => ({ ...prev, [voteId]: true }));
      }
    }
  };

  const handleFaceRecognitionSuccess = () => {
    setIsSignIn(true);
  };

  const handleFilterChange = (newFilters) => {
    setActiveFilters(newFilters);
    if (newFilters.all && onRefresh) {
      console.log("Full refresh requested via 'All' filter");
      onRefresh();
    } else {
      // Reset pagination and reload votes with new filters
      setCurrentPage(0);
      setHasMoreVotes(true);
      handleAllVotes(true, newFilters);
    }
  };

  // Ensure "All" filter is always the default
  useEffect(() => {
    if (!activeFilters.all && !Object.values(activeFilters).some(v => v === true)) {
      const defaultFilters = {
        all: true,
        recentlyAdded: false,
        expiringSoon: false,
        isFaceRequired: false,
        isLocation: false,
        isNotVoted: false,
        mostPopular: false,
        mostUnanimous: false,
        mostDivided: false,
        mostLiked: false,
        mostCommented: false
      };
      setActiveFilters(defaultFilters);
    }
  }, [activeFilters]);


  const displayedVotes = React.useMemo(() => {
    if (!allVotes || !Array.isArray(allVotes)) return [];
    let list = allVotes;

    if (searchTerm.trim()) {
      const term = searchTerm.toLowerCase().trim();
      list = list.filter(v => {
        const title = (v.title || "").toLowerCase();
        const desc = (v.description || "").toLowerCase();
        const tags = Array.isArray(v.tags) ? v.tags.join(" ").toLowerCase() : (v.tags || "").toLowerCase();
        const party = (v.politicalAffiliation || v.createdByUserPoliticalAffiliation || "").toLowerCase();
        const creator = (v.createdByName || "").toLowerCase();
        const options = Array.isArray(v.options) ? v.options.map(o => o.optionText || "").join(" ").toLowerCase() : "";
        return title.includes(term) || desc.includes(term) || tags.includes(term) || party.includes(term) || creator.includes(term) || options.includes(term);
      });
    }

    return list;
  }, [allVotes, searchTerm]);

  return (
    <div className="Feeds">
      <VoteFilters
        onFilterChange={handleFilterChange}
        activeFilters={activeFilters}
      />
      {/* Ballot Search Bar */}
      <div className="ballotSearchBarContainer">
        <div className="ballotSearchInputWrap">
          <SearchRoundedIcon sx={{ color: '#5AAF9A', fontSize: 20 }} />
          <input
            type="text"
            className="ballotSearchInputField"
            placeholder="Search ballots by keyword, question, or tag..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          {searchTerm && (
            <button className="ballotClearSearchBtn" onClick={() => setSearchTerm('')} title="Clear search">
              <CloseIcon sx={{ fontSize: 16 }} />
            </button>
          )}
        </div>
      </div>

      {searchTerm && (
        <div className="ballotSearchResultsInfo">
          <span>
            Found <strong>{displayedVotes.length}</strong> ballot{displayedVotes.length === 1 ? '' : 's'} matching "<strong>{searchTerm}</strong>"
          </span>
        </div>
      )}

      <div className="feedsContainer">
        {isLoading ?
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '40vh', width: '100%', gap: '20px' }}>
            <Loader containerSize="3rem" />
            <p style={{
              color: '#ffffff',
              fontWeight: '600',
              fontSize: '1rem',
              textTransform: 'uppercase',
              letterSpacing: '1.5px',
              textAlign: 'center',
              maxWidth: '90%',
              lineHeight: '1.4',
              fontFamily: '"Inter", sans-serif',
              opacity: 0.8
            }}>
              Hang tight, we’re getting things ready for you...
            </p>
          </div>
          :
          <div className="feedCardContainer">
            {displayedVotes && Array.isArray(displayedVotes) && displayedVotes.length > 0 ? (
              displayedVotes.map((item, index) => (
                <div key={index} className="feedCard" ref={el => voteRefs.current[item.voteId] = el} data-vote-id={item.voteId}>
                  <div className="feedBody">
                    <div className="feedCardHeader">
                      <div className="profileDetailsContainer">
                        {item.createdByUserPhoto ? (
                          <div style={{ position: 'relative' }}>
                            {profileImageLoading[item.voteId] && (
                              <div style={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                zIndex: 2
                              }}>
                                <CircularProgress size={20} sx={{ color: '#5AAF9A' }} />
                              </div>
                            )}
                            <img
                              src={item.createdByUserPhoto}
                              alt="no-img-found"
                              className="profilePic"
                              onLoad={() => handleImageLoad(item.voteId, 'profile')}
                              onError={() => handleImageError(item.voteId, 'profile')}
                              onLoadStart={() => setMediaLoading(item.voteId, 'profile', true)}
                              style={{
                                opacity: profileImageLoading[item.voteId] ? 0.3 : 1,
                                transition: 'opacity 0.3s ease'
                              }}
                            />
                          </div>
                        ) : (
                          <div
                            className="profilePic"
                            style={{
                              backgroundColor: getBackgroundColor(getUserInitials(item?.displayName)),
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              color: 'white',
                              fontWeight: 'bold',
                              fontSize: '16px',
                              fontFamily: 'Arial, sans-serif'
                            }}
                          >
                            {getUserInitials(item?.displayName ? item.displayName : item.createdByUserName)}
                          </div>
                        )}
                        <div className="profileDetails">
                          <span className="profileNameText">{item.displayName || item.createdByUserName || 'Unknown User'}</span>
                        </div>
                      </div>
                      <div className="timeContainer">
                        {item.isPaused ? <div className="pausedContainer"><span className="pausedtext">Paused</span></div> : <div className="timeContainer"><span className="timeText">{getHumanizedTime(item?.createdOn)}</span></div>}
                        <img
                          src="/Assets/Sidebar/helpCenterIcon.svg"
                          alt="no img found"
                          className="infoIcon"
                          onClick={(e) => handleHelpClick(e, item.voteId, item.bookmarkId)}
                        />
                      </div>
                    </div>
                    <div className="feedCardVoteTitleContainer">
                      <span className="voteTitleText">
                        {item.title}
                      </span>
                    </div>
                    {item?.imageUrls && Array.isArray(item.imageUrls) && item.imageUrls.length > 0 && <div className="voteMediaContainer" style={{ position: 'relative' }}>
                      {imageLoading[item.voteId] && (
                        <div style={{
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%, -50%)',
                          zIndex: 2,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}>
                          <CircularProgress size={40} sx={{ color: '#5AAF9A' }} />
                        </div>
                      )}
                      {item?.imageUrls?.[0] && <img
                        src={item?.imageUrls?.[0] || "/Sidebar/voteImage.svg"}
                        alt="no-img-found"
                        className="voteMedia"
                        onLoad={() => handleImageLoad(item.voteId, 'main')}
                        onError={() => handleImageError(item.voteId, 'main')}
                        onLoadStart={() => setMediaLoading(item.voteId, 'main-image', true)}
                        style={{
                          opacity: imageLoading[item.voteId] ? 0.3 : 1,
                          transition: 'opacity 0.3s ease'
                        }}
                      />}
                    </div>}
                    {item?.videoUrl && item.videoUrl.trim() !== '' && <div className="voteMediaContainer" style={{ position: 'relative' }}>
                      {videoLoading[item.voteId] && (
                        <div style={{
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%, -50%)',
                          zIndex: 2,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}>
                          <CircularProgress size={40} sx={{ color: '#5AAF9A' }} />
                        </div>
                      )}
                      <video
                        src={item?.videoUrl}
                        alt="no-video-found"
                        className="voteMedia"
                        muted={unmutedVideoId !== item.voteId}
                        loop
                        onPlay={() => setPlayingVideos(prev => ({ ...prev, [item.voteId]: true }))}
                        onPause={() => setPlayingVideos(prev => ({ ...prev, [item.voteId]: false }))}
                        onLoadStart={() => setMediaLoading(item.voteId, 'main-video', true)}
                        onLoadedData={() => handleVideoLoad(item.voteId, 'main')}
                        onError={() => setVideoLoading(prev => ({ ...prev, [item.voteId]: false }))}
                        onClick={(e) => handleVideoPlayPause(item.voteId, e)}
                        style={{
                          cursor: "pointer",
                          opacity: videoLoading[item.voteId] ? 0.3 : 1,
                          transition: 'opacity 0.3s ease'
                        }}
                      />

                      {/* Play/Pause Button Overlay */}
                      {!playingVideos[item.voteId] && !videoLoading[item.voteId] && (
                        <div
                          className="playPauseOverlay"
                          style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            cursor: 'pointer',
                            zIndex: 10
                          }}
                          onClick={(e) => handleVideoPlayPause(item.voteId, e)}
                        >
                          <PlayArrowRoundedIcon
                            sx={{
                              color: "#5AAF9A",
                              fontSize: { xs: "50px", sm: "50px", md: "50px", lg: "70px" },
                              cursor: "pointer",
                            }}
                          />
                        </div>
                      )}

                      <div className="volumeControlContainer" style={{
                        position: 'absolute',
                        top: '10px',
                        right: '10px',
                        background: 'rgba(0, 0, 0, 0.5)',
                        borderRadius: '50%',
                        padding: '4px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        opacity: videoLoading[item.voteId] ? 0.3 : 1,
                        transition: 'opacity 0.3s ease'
                      }}
                        onClick={(e) => handleVolumeToggle(item.voteId, e)}
                      >
                        {unmutedVideoId === item.voteId ? (
                          <VolumeUpIcon
                            // onClick={(e) => handleVolumeToggle(item.voteId, e)}
                            sx={{
                              color: "#fff",
                              fontSize: { xs: "10px", sm: "13px", md: "15px", lg: "20px" },
                              cursor: "pointer",
                              "&:hover": { opacity: 0.8 }
                            }}
                          />
                        ) : (
                          <VolumeOffIcon
                            // onClick={(e) => handleVolumeToggle(item.voteId, e)}
                            sx={{
                              color: "#fff",
                              fontSize: { xs: "10px", sm: "13px", md: "15px", lg: "20px" },
                              cursor: "pointer",
                              "&:hover": { opacity: 0.8 }
                            }}
                          />
                        )}
                      </div>
                    </div>
                    }
                    {
                      item?.fileUrl && item.fileUrl.trim() !== '' && item.fileUrl.endsWith('.pdf') && (
                        <div className="pdfLinkContainer">
                          <a
                            href={`https://drive.google.com/viewerng/viewer?url=${encodeURIComponent(item.fileUrl)}&embedded=true`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="pdfLink"
                          >
                            <PictureAsPdfRoundedIcon sx={{ color: "black", fontSize: { xs: "15px", sm: "20px", md: "20px", lg: "25px" } }} />
                            View PDF
                          </a>
                        </div>
                      )
                    }
                    <div className="voteDescriptionContainer">
                      <span className="voteDescriptionText">{item.description}</span>
                    </div>
                    <div className="voteBtnsContainer">
                      {item.options && Array.isArray(item.options) && item.options.map((option) => {
                        const loadingKey = `${item.voteId}-${option.id}`;
                        const isLoading = votingLoader[loadingKey];
                        return (
                          <div key={option.id} style={{ position: 'relative' }}>
                            <button
                              className={`vote-button-wrapper ${item.isVoted ? 'voted' : ''} ${item.selectedOptionId === option.id ? 'selected' : ''}`}
                              onClick={() => !item.isVoted && !isLoading && handleSubmitVote(item.voteId, option.id)}
                              disabled={item.isVoted || item.isPaused || isLoading}
                              style={{ position: 'relative' }}
                            >
                              {isLoading && (
                                <CircularProgress
                                  size={20}
                                  sx={{
                                    color: '#5AAF9A',
                                    position: 'absolute',
                                    left: '50%',
                                    top: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    zIndex: 1
                                  }}
                                />
                              )}
                              {item.selectedOptionId && item.selectedOptionId.toLowerCase() === option.id && (
                                <div
                                  className="vote-progress-bar"
                                  style={{ width: `${option.percentage}%` }}
                                />
                              )}
                              <span
                                className={`vote-text ${item.isVoted ? 'voted' : ''}`}
                                style={{ opacity: isLoading ? 0.3 : 1 }}
                              >
                                {option.value}
                              </span>
                              {item.isVoted && (
                                <span className={`vote-percentage ${item.isVoted ? 'voted' : ''}`}>{option.percentage}%</span>
                              )}
                            </button>

                          </div>
                        );
                      })}
                    </div>

                    {/* View Sub-Ballot Button - below options */}
                    {item.isVoted && item.selectedOptionId && (
                      <div className="view-sub-ballot-container">
                        {(() => {
                          const selectedOption = item.options.find(opt => opt.id.toLowerCase() === item.selectedOptionId.toLowerCase());
                          if (selectedOption) {
                            return (
                              <button
                                className="view-sub-ballot-btn-main"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleViewSubBallot(item.voteId, selectedOption.id, selectedOption.value);
                                }}
                              >
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                  <path d="M9 18l6-6-6-6" />
                                </svg>
                                <span>View Follow-up Question</span>
                              </button>
                            );
                          }
                          return null;
                        })()}
                      </div>
                    )}
                    <div className="voteDetailsContainer">
                      <div className="voteActionContainer">
                        <div className={`voteActionContainer2 ${item.isLiked ? 'liked' : ''}`} onClick={() => handleLikeDislike(item.voteId)}>
                          {item.isLiked ? (
                            <FavoriteRoundedIcon sx={{ color: "#FF0000", fontSize: { xs: "15px", md: "20px", sm: "15px", lg: "25px" } }} />
                          ) : (
                            <FavoriteBorderRoundedIcon sx={{ color: "#fff", fontSize: { xs: "15px", md: "20px", sm: "15px", lg: "25px" } }} />
                          )}
                          <span className={`feedCardFooterText ${item.isLiked ? 'liked-text' : ''}`}>{item.likeCount}</span>
                        </div>
                        <div className="voteActionContainer2" onClick={() => handleCommentIconClick(item.voteId, item.commentCount)}>
                          <ChatBubbleOutlineRoundedIcon sx={{ color: "#fff", fontSize: { xs: "15px", md: "20px", sm: "15px", lg: "25px" } }} />
                          <span className="feedCardFooterText">{item.commentCount}</span>
                        </div>
                      </div>
                      <div className="voteShareContainer">
                        {/* <img
                          src="/Sidebar/send.svg"
                          alt="no-img-found"
                          className="feedCardFooterIcon"
                          onClick={() => handleShare(item)}
                        /> */}
                        <NearMeOutlinedIcon sx={{ color: "#fff", fontSize: { xs: "15px", md: "20px", sm: "15px", lg: "25px" } }} onClick={() => handleShare(item)} />
                      </div>
                    </div>
                    {openComments[item.voteId] && (
                      <div className="commentContainer">
                        <div className="commentInputContainer">
                          <input
                            type="file"
                            ref={fileInputRef}
                            style={{ display: 'none' }}
                            onChange={(e) => handleFileSelect(e, item.voteId)}
                            accept="image/*,video/*"
                            className="feedsCommentInput"
                          />
                          {filePreviews[item.voteId] ? (
                            <div className="filePreviewContainer" style={{ position: 'relative' }}>
                              {previewLoading[item.voteId] && (
                                <div style={{
                                  position: 'absolute',
                                  top: '50%',
                                  left: '50%',
                                  transform: 'translate(-50%, -50%)',
                                  zIndex: 2,
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center'
                                }}>
                                  <CircularProgress size={30} sx={{ color: '#5AAF9A' }} />
                                </div>
                              )}
                              {selectedFiles[item.voteId]?.type.startsWith('image/') ? (
                                <img
                                  src={filePreviews[item.voteId]}
                                  alt="Selected"
                                  className="filePreview"
                                  onLoad={() => handleImageLoad(item.voteId, 'preview')}
                                  onError={() => handleImageError(item.voteId, 'preview')}
                                  onLoadStart={() => setMediaLoading(item.voteId, 'preview', true)}
                                  style={{
                                    opacity: previewLoading[item.voteId] ? 0.3 : 1,
                                    transition: 'opacity 0.3s ease'
                                  }}
                                />
                              ) : selectedFiles[item.voteId]?.type.startsWith('video/') ? (
                                <video
                                  src={filePreviews[item.voteId]}
                                  className="filePreview"
                                  muted
                                  autoPlay
                                  loop
                                  onLoadStart={() => setMediaLoading(item.voteId, 'preview', true)}
                                  onLoadedData={() => handleVideoLoad(item.voteId, 'preview')}
                                  onError={() => setPreviewLoading(prev => ({ ...prev, [item.voteId]: false }))}
                                  style={{
                                    opacity: previewLoading[item.voteId] ? 0.3 : 1,
                                    transition: 'opacity 0.3s ease'
                                  }}
                                />
                              ) : null}
                            </div>
                          ) : (
                            <textarea
                              placeholder="Add a comment..."
                              className="feedsCommentInput"
                              value={commentText}
                              onChange={(e) => setCommentText(e.target.value)}
                            />
                          )}
                          <div className="commentButtonContainer">
                            <button
                              className="commentButton"
                              onClick={() => filePreviews[item.voteId] ? clearFileSelection(item.voteId) : handlePlusClick()}
                            >
                              {filePreviews[item.voteId] ? (
                                <CloseRoundedIcon sx={{ color: "#070F0F", fontSize: { xs: "15px", md: "20px", sm: "15px", lg: "25px" } }} />
                              ) : (
                                <AddRoundedIcon sx={{ color: "#070F0F", fontSize: { xs: "15px", md: "20px", sm: "15px", lg: "25px" } }} />
                              )}
                            </button>
                            <button className="commentButton" onClick={() => handleCommentSubmit(item.voteId)}>
                              <SendRoundedIcon sx={{ color: "#070F0F", fontSize: { xs: "15px", md: "20px", sm: "15px", lg: "25px" } }} />
                            </button>
                          </div>
                        </div>
                        <div className="existingCommentsContainer">
                          {allComments.length > 0 && allComments.map((comment) => (
                            <div key={comment.commentId} className="commentItem">
                              <div className="commentItemContainer"><div className="commentHeader">
                                {comment.userPhoto ? (
                                  <div style={{ position: 'relative' }}>
                                    {commentProfileLoading[comment.commentId] && (
                                      <div style={{
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        transform: 'translate(-50%, -50%)',
                                        zIndex: 2
                                      }}>
                                        <CircularProgress size={15} sx={{ color: '#5AAF9A' }} />
                                      </div>
                                    )}
                                    <img
                                      src={comment.userPhoto}
                                      alt={comment.userName}
                                      className="commentUserPhoto"
                                      onLoad={() => handleImageLoad(comment.commentId, 'commentProfile')}
                                      onError={() => handleImageError(comment.commentId, 'commentProfile')}
                                      onLoadStart={() => setMediaLoading(comment.commentId, 'commentProfile', true)}
                                      style={{
                                        opacity: commentProfileLoading[comment.commentId] ? 0.3 : 1,
                                        transition: 'opacity 0.3s ease'
                                      }}
                                    />
                                  </div>
                                ) : (
                                  <div
                                    className="commentUserPhoto"
                                    style={{
                                      backgroundColor: getBackgroundColor(getUserInitials(comment.userName)),
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      color: 'white',
                                      fontWeight: 'bold',
                                      fontSize: '14px',
                                      fontFamily: 'Arial, sans-serif'
                                    }}
                                  >
                                    {getUserInitials(comment?.userName)}
                                  </div>
                                )}
                                <div className="commentUserInfo">
                                  <span className="commentUserName">{comment.userName}</span>
                                  <span className="commentTime">
                                    {getHumanizedTime(comment?.createdAt)}
                                  </span>
                                </div>
                              </div>
                                {comment.videoUrl && <div className="commentVideoContainer" style={{ position: 'relative' }}>
                                  {commentMediaLoading[comment.commentId] && (
                                    <div style={{
                                      position: 'absolute',
                                      top: '50%',
                                      left: '50%',
                                      transform: 'translate(-50%, -50%)',
                                      zIndex: 2,
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center'
                                    }}>
                                      <CircularProgress size={25} sx={{ color: '#5AAF9A' }} />
                                    </div>
                                  )}
                                  {comment?.videoUrl?.match(/\.(mp4|webm|ogg)$/i) ? (
                                    <video
                                      src={comment?.videoUrl}
                                      className="commentVideo"
                                      muted
                                      autoPlay
                                      loop
                                      onLoadStart={() => setMediaLoading(comment.commentId, 'comment', true)}
                                      onLoadedData={() => handleVideoLoad(comment.commentId, 'comment')}
                                      onError={() => setCommentMediaLoading(prev => ({ ...prev, [comment.commentId]: false }))}
                                      style={{
                                        opacity: commentMediaLoading[comment.commentId] ? 0.3 : 1,
                                        transition: 'opacity 0.3s ease'
                                      }}
                                    />
                                  ) : (
                                    <img
                                      src={comment?.videoUrl}
                                      alt="comment media"
                                      className="commentVideo"
                                      onLoad={() => handleImageLoad(comment.commentId, 'comment')}
                                      onError={() => handleImageError(comment.commentId, 'comment')}
                                      onLoadStart={() => setMediaLoading(comment.commentId, 'comment', true)}
                                      style={{
                                        opacity: commentMediaLoading[comment.commentId] ? 0.3 : 1,
                                        transition: 'opacity 0.3s ease'
                                      }}
                                    />
                                  )}
                                </div>}
                                {comment?.commentText?.trim() && <div className="commentText">
                                  {comment?.commentText.trim()}
                                </div>}
                                <div className="commentActionsRow" style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '6px' }}>
                                  <div style={{ display: 'flex', alignItems: 'center', background: '#2a2a2a', borderRadius: '12px', padding: '2px' }}>
                                    <KeyboardArrowUpRoundedIcon 
                                      sx={{ 
                                        color: comment.isLiked ? "#5AAF9A" : "#808080", 
                                        fontSize: "20px", 
                                        cursor: comment.isLiked ? "default" : "pointer",
                                        "&:hover": { color: comment.isLiked ? "#5AAF9A" : "#ffffff" }
                                      }}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleCommentLikeDislike(comment.voteId, comment.commentId, 'up');
                                      }}
                                    />
                                    <span style={{ fontSize: '13px', fontWeight: 'bold', color: '#fff', margin: '0 4px', minWidth: '12px', textAlign: 'center' }}>
                                      {comment.likeCount || 0}
                                    </span>
                                    <KeyboardArrowDownRoundedIcon 
                                      sx={{ 
                                        color: !comment.isLiked ? "#808080" : "#808080",
                                        fontSize: "20px", 
                                        cursor: !comment.isLiked ? "default" : "pointer",
                                        "&:hover": { color: !comment.isLiked ? "#808080" : "#ffffff" }
                                      }}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleCommentLikeDislike(comment.voteId, comment.commentId, 'down');
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                              {
                                comment?.userId === userId && (
                                  <div className="commentItemContainer">
                                    <button
                                      className="deleteCommentBtn"
                                      onClick={() => handleDeleteComment(comment.commentId, comment.voteId)}
                                    >
                                      <DeleteOutlineIcon sx={{ color: "#C15F5F", fontSize: "20px", cursor: "pointer" }} />
                                    </button>
                                  </div>
                                )
                              }


                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ))
            ) : (
              <div style={{
                textAlign: 'center',
                padding: '40px 20px',
                color: '#808080',
                fontSize: '16px'
              }}>
                No votes found. Try adjusting your filters.
              </div>
            )}
            {isLoadingMore && (
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                padding: '20px',
                width: '100%'
              }}>
                <CircularProgress size={40} sx={{ color: '#5AAF9A' }} />
              </div>
            )}
            {!hasMoreVotes && allVotes.length > 0 && (
              <div style={{
                textAlign: 'center',
                padding: '20px',
                color: '#808080',
                fontSize: '14px'
              }}>
                No more votes to load
              </div>
            )}
            {hasMoreVotes && !isLoadingMore && allVotes.length > 0 && (
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                padding: '20px'
              }}>
                <button
                  onClick={loadMoreVotes}
                  style={{
                    backgroundColor: '#5AAF9A',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    padding: '12px 24px',
                    fontSize: '14px',
                    cursor: 'pointer',
                    fontWeight: '500',
                    transition: 'background-color 0.3s ease'
                  }}
                  onMouseOver={(e) => e.target.style.backgroundColor = '#48D1CC'}
                  onMouseOut={(e) => e.target.style.backgroundColor = '#5AAF9A'}
                >
                  Load More Votes
                </button>
              </div>
            )}
          </div>
        }

      </div>
      {showPopup && (
        <div className="popupOverlay" onClick={handleClickOutside}>
          <div
            className="popupContent"
            style={{
              top: `${popupPosition.top}px`,
              left: `${popupPosition.left}px`
            }}
          >
            <span className="popupTitle">Information</span>
            {
              bookmarkedVotes.map((item) => item.voteId).includes(selectedCardId) ? (<button className="popupBtn saveBtn" onClick={() => handleUnSave(selectedCardId)}>
                <img src="/Assets/Sidebar/saveIcon.svg" alt="no-img-found" className="informationBtnIcon" />
                <span className="informationBtnText">Unsave</span>
              </button>) : <button className="popupBtn saveBtn" onClick={() => handleSave(selectedCardId)}>
                <img src="/Assets/Sidebar/saveIcon.svg" alt="no-img-found" className="informationBtnIcon" />
                <span className="informationBtnText">Save</span>
              </button>
            }

            <button className="popupBtn reportBtn" onClick={handleReport}>
              <img src="/Assets/Sidebar/reportIcon.svg" alt="no-img-found" className="informationBtnIcon" />
              <span className="reportBtnText">Report this content</span>
            </button>
            {isReportClicked && <div className="reportReasonContainer">
              <span className="informationBtnText">Select a reason</span>
              <div className="reportReasonOptions">
                <span className="reportReasonOption" onClick={handleReportOption}>Harmful or Dangerous Content</span>
                <span className="reportReasonOption" onClick={handleReportOption}>Harrasment or Hate Speech</span>
                <span className="reportReasonOption" onClick={handleReportOption}>Sexual or Inappropriate Content</span>
                <span className="reportReasonOption" onClick={handleReportOption}>Spam or misleading</span>
                <span className="reportReasonOption" onClick={handleReportOption}>Violent or Graphic Content</span>
                <span className="reportReasonOption" onClick={handleReportOption}>Other</span>
              </div>
            </div>}
          </div>
        </div>
      )}

      <ShareModal
        open={shareDialogOpen}
        onClose={() => setShareDialogOpen(false)}
        item={selectedVoteForShare}
        shareType="ballot"
        onToast={(msg) => {
          setSnackbarMessage(msg);
          setSnackbarOpen(true);
        }}
      />

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      />

      <Dialog
        open={faceRecognitionDialogOpen}
        onClose={() => {
          setFaceRecognitionDialogOpen(false);
          setPendingVote(null);
        }}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            width: '90%',
            maxWidth: '800px',
            borderRadius: 3,
            overflow: 'hidden',
            backgroundColor: '#0e1b1b',
            position: 'relative',
            padding: 0,
          }
        }}
      >
        <div style={{
          position: 'relative',
          padding: '40px 20px',
          backgroundImage: 'url(/Assets/SignInFaceRecognition/containerbackgroundImage.svg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          minHeight: '600px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <CloseIcon
            onClick={() => {
              setFaceRecognitionDialogOpen(false);
              setPendingVote(null);
            }}
            sx={{
              position: 'absolute',
              right: 16,
              top: 16,
              color: 'white',
              cursor: 'pointer',
              fontSize: 28,
              zIndex: 10,
            }}
            aria-label="close"
          />
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '30px',
            width: '100%',
            maxWidth: '700px'
          }}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '10px',
              marginBottom: '10px'
            }}>
              <span style={{
                color: 'white',
                fontSize: '24px',
                fontWeight: 'bold'
              }}>
                Face Recognition
              </span>
              <span style={{
                color: '#ccc',
                fontSize: '14px',
                textAlign: 'center'
              }}>
                Please look into the camera and hold still
              </span>
            </div>
            <FaceRecognition
              isUserVerified={'verified'}
              onSuccess={handleFaceRecognitionSuccess}
              onCancel={() => {
                setFaceRecognitionDialogOpen(false);
                setPendingVote(null);
              }}
            />
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '5px',
              marginTop: '10px'
            }}>
              <span style={{
                color: 'white',
                fontSize: '16px',
                fontWeight: '500'
              }}>
                Live human Recognized
              </span>
              <span style={{
                color: '#ccc',
                fontSize: '12px',
                textAlign: 'center'
              }}>
                Smile & blink your eyes, then move your head slowly to complete the process.
              </span>
            </div>
          </div>
        </div>
      </Dialog>
      <SubscriptionPrompt
        open={subscriptionDialogOpen}
        onClose={() => setSubscriptionDialogOpen(false)}
        message={"Please purchase a subscription from the Android or iOS app to vote, like or comment."}
      />
      <ProfileCompletionPrompt
        open={profilePromptOpen}
        onClose={() => setProfilePromptOpen(false)}
        message={profilePromptMessage || "Complete your profile, Register Your Face & Verify Your Identity to continue."}
        actionLabel="GOT IT"
        secondaryAction={null}
        onPrimaryAction={() => setProfilePromptOpen(false)}
      />

      {/* Sub-Ballot Modal */}
      {isSubBallotOpen && subBallot && (
        <SubBallotModal
          subBallot={subBallot}
          parentOptionText={parentOptionText}
          onSubmit={handleSubBallotVote}
          onClose={handleCloseSubBallot}
          isLoading={isSubBallotVoting}
        />
      )}
    </div>
  );
}

export default Feeds;
